<template>
  <div>
    <!-- MODO NORMAL -->
    <div v-if="!printMode">
      <h6>{{ props.printTitle }}</h6><p></p>
      <button @click="abrirPrint" class="btn btn-primary mb-3">
        Executar
      </button>
    </div>

    <!-- MODO IMPRESSÃO -->
    <div v-else>
      <div v-if="loadingContagem || loadingAlunos" class="mb-3">
        Carregando…
      </div>

      <div v-else>
        <!-- RESUMO -->
        <table class="table table-bordered mb-4" style="width:auto;">
          <thead>
            <tr class="text-center">
              <th>Encerrado (≤120d)</th>
              <th>Arquivado (>120d)</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-center">
              <td>{{ counts.encerrado }}</td>
              <td>{{ counts.arquivado }}</td>
              <td>{{ counts.total }}</td>
            </tr>
          </tbody>
        </table>

        <!-- LISTA -->
        <div v-if="!loadingAlunos && resultados.length">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>MAT</th>
                <th>NOME</th>
                <th>E-MAIL</th>
                <th>CELULAR</th>
                <th>RESPONSÁVEL</th>
                <th>STATUS</th>
                <th class="text-center">INÍCIO</th>
                <th class="text-center">TÉRMINO</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="aluno in resultados"
                :key="aluno.matricula_id"
                :class="{
                    'table-warning':  aluno.status === 'Encerrado',
                    'table-secondary': aluno.status === 'Arquivado'
                }"
              >
                <td>{{ aluno.matricula_id }}</td>
                <td>{{ aluno.nome }}</td>
                <td>{{ aluno.email || '' }}</td>
                <td>{{ aluno.celular || '' }}</td>
                <td>{{ aluno.responsavel || '' }}</td>
                <td>{{ aluno.status }}</td>
                <td class="text-center">{{ formatarData(aluno.inicio_vigencia) }}</td>
                <td class="text-center">{{ formatarData(aluno.termino_vigencia) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else-if="!loadingAlunos && executedAlunos">
          <p>Não há Matrículas Inativas neste momento.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'

// PROPS
const props = defineProps({
  printMode:  { type: Boolean, default: false },
  printTitle: { type: String,  default: 'Lista de Matrículas Inativas' }
})

const router = useRouter()

// ESTADOS
const counts           = ref({ encerrado: 0, arquivado: 0, total: 0 })
const loadingContagem  = ref(false)

const loadingAlunos   = ref(false)
const resultados      = ref([])
const executedAlunos  = ref(false)

// BUSCAS
async function buscarContagem() {
  loadingContagem.value = true
  try {
    const res = await axios.get('/gestao/relatorios/cadastrais/lista-alunos-inativos/contagem-matriculas')
    counts.value = {
      encerrado: res.data.encerrado ?? 0,
      arquivado: res.data.arquivado ?? 0,
      total:     res.data.total     ?? 0
    }
  } catch (err) {
    console.error('Erro ao buscar contagem (inativas):', err)
  } finally {
    loadingContagem.value = false
  }
}

async function buscarAlunosInativos() {
  loadingAlunos.value   = true
  executedAlunos.value  = false
  resultados.value      = []
  try {
    const res = await axios.get('/gestao/relatorios/cadastrais/lista-alunos-inativos')
    resultados.value = Array.isArray(res.data) ? res.data : []
  } catch (err) {
    console.error('Erro ao buscar Matrículas Inativas:', err)
    resultados.value = []
  } finally {
    loadingAlunos.value   = false
    executedAlunos.value  = true
  }
}

// MODO IMPRESSÃO
onMounted(() => {
  if (!props.printMode) return
  buscarContagem()
  buscarAlunosInativos()
})

function abrirPrint() {
  router.push({
    path: `/gestao/relatorios/print/alunos-inativos`,
    query: { title: props.printTitle }
  })
}

function formatarData(dateStr) {
  if (!dateStr) return ''
  const d   = new Date(dateStr)
  const dia = String(d.getDate()).padStart(2, '0')
  const mes = String(d.getMonth() + 1).padStart(2, '0')
  const ano = d.getFullYear()
  return `${dia}/${mes}/${ano}`
}
</script>

<style scoped>
.mb-3 { margin-bottom: 1rem; }
.table-bordered { width: auto; margin-bottom: 1rem; }
.text-center { text-align: center; }
.table-danger { background-color: #f8d7da !important; }   /* Expirada */
.table-secondary { background-color: #f8f9fa !important; }/* Futura  */
</style>
